import React, { useEffect, useState, useCallback } from 'react';
import './SplashScreen.css';
import splashGif from '../assets/Splash Screen.gif';

function SplashScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);

  const handleComplete = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      onComplete();
    }, 500); // Wait for fade out animation
  }, [onComplete]);

  useEffect(() => {
    // Auto-complete after 5 seconds (adjust timing as needed)
    const timer = setTimeout(() => {
      handleComplete();
    }, 7000);

    return () => clearTimeout(timer);
  }, [handleComplete]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${!isVisible ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <img src={splashGif} alt="Loading" className="splash-gif" />
        <button onClick={handleComplete} className="skip-button">
          Skip
        </button>
      </div>
    </div>
  );
}

export default SplashScreen;
